import { Form, FormField, Data, ModalId, useUIActions, useUIStateActions, ConfirmWarningsModal } from '../../../ui'
import { DataType } from '../../../../tables'
import { toFieldTypeValue } from '../../utils/dataTypesUtils'
import { useRoutesHooks } from '../../../routes'
import { Emitter, Event } from '../../../event-emitter'
import { useState } from 'react'

type Props = {
    formId: string
    fields: FormField[]
    defaultDataType?: DataType
    createMode?: boolean
    createLabel?: string
    updateLabel?: string
    disableSubmit?: boolean
    onSubmit: (data: Data) => void
    onCancel: () => void
    validate?: () => Promise<string[]>
    // Advertencias que no bloquean: si hay, se piden confirmar antes de guardar (ej. vender sin stock)
    warn?: () => Promise<string[]>
    warnTitle?: string
    warnDescription?: string
    warnSubmitLabel?: string
    warnCancelLabel?: string
}

export const DataTypeForm2 = (props: Props) => {
    const { formId, fields, defaultDataType, createMode = true, createLabel, updateLabel, disableSubmit, onSubmit, onCancel, validate, warn, warnTitle = 'Advertencias', warnDescription, warnSubmitLabel, warnCancelLabel } = props
    const urlData = useRoutesHooks().parseUrl()
    const dataType = defaultDataType || urlData.secondDataType || urlData.dataType

    const [submitting, setSubmitting] = useState(false)
    const [warnings, setWarnings] = useState<string[]>([])
    const [pendingData, setPendingData] = useState<Data>()

    const { setModalValidations } = useUIStateActions()
    const { openModal, closeModal } = useUIActions()

    const dataTypeFields: FormField[] = fields.map(field => {
        const value = field.value || toFieldTypeValue(field.type, dataType?.[field.name as keyof DataType])
        const defaultValue = field.defaultValue
        return {
            ...field,
            defaultValue: createMode ? defaultValue : value || defaultValue
        }
    })

    const submit = (data: Data) => onSubmit({
        ...data,
        ...(!createMode && {
            id: dataType!.id
        })
    })

    const handleSubmit = async (data: Data) => {
        setSubmitting(true)
        !!validate && Emitter.emit(Event.DB_SUBMIT)
        setModalValidations([])

        const validations = validate ? await validate() : []
        if (validations.length === 0) {
            const newWarnings = warn ? await warn() : []
            if (newWarnings.length === 0) {
                submit(data)
            } else {
                closeModal(ModalId.SPINNER)
                setWarnings(newWarnings)
                setPendingData(data)
                setTimeout(() => openModal(ModalId.WARNING_CONFIRM), 500)
            }
        } else {
            closeModal(ModalId.SPINNER)
            setModalValidations(validations)
            setTimeout(() => openModal(ModalId.VALIDATION), 500)
        }
        setSubmitting(false)
    }

    const onConfirmWarnings = () => {
        if (!pendingData) return
        Emitter.emit(Event.DB_SUBMIT)
        submit(pendingData)
    }

    return (
        <>
            <Form
                formId={formId}
                fields={dataTypeFields}
                createMode={createMode}
                createLabel={createLabel}
                updateLabel={updateLabel}
                disableSubmit={disableSubmit || submitting}
                onSubmit={handleSubmit}
                onCancel={onCancel}
            />
            {warn && (
                <ConfirmWarningsModal
                    title={warnTitle}
                    warnings={warnings}
                    description={warnDescription}
                    submitLabel={warnSubmitLabel}
                    cancelLabel={warnCancelLabel}
                    onConfirm={onConfirmWarnings}
                />
            )}
        </>
    )
}
